<template>
  <div class="box">
    <div class="box_1"></div>
    <div class="box_2">
      <div class="top_box">
        <div class="top_item_box">
          <div class="t1">商务合作</div>
          <div class="t2">
            <div class="logo"></div>
            <div class="t_1">微信：J1anZ6</div>
          </div>
          <div class="t3">
            <div class="logo"></div>
            <div class="t_1">QQ：335111628</div>
          </div>
        </div>
        <div class="top_item_box">
          <div class="t1">反馈建议</div>
          <!-- <div class="t2">
            <div class="logo"></div>
            <div class="t_1">微信：aabbccdd</div>
          </div> -->
          <div class="t3">
            <div class="logo"></div>
            <div class="t_1">QQ：3658465198</div>
          </div>
        </div>
      </div>
    </div>
    <div class="box_3"></div>
    <div class="kong"></div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  created() {},

  methods: {},
};
</script>
<style scoped lang="less">
.box {
  //   border: 1px solid red;
  width: 100%;
  height: 100%;
  //   background: #000;
  //   background: linear-gradient(to right, #fff,#aaa);
  display: flex;
  flex-direction: column;
  align-items: center;
  .box_1 {
    width: 100%;
    height: 310px;
    background: url(~@/assets/images/contactus.png);
    background-size: cover;
    background-repeat: no-repeat;
  }
  .box_2 {
    width: 100%;
    // height: 532px;
    background: #081031;
    display: flex;
    flex-direction: column;
    align-items: center;
    .top_box {
      margin-top: 84px;
      width: 740px;
      height: 260px;
      // border: 1px solid red;
      display: flex;
      justify-content: space-between;
      .top_item_box {
        display: flex;
        flex-direction: column;
        width: 348px;
        height: 260px;
        border-radius: 10px;
        background: #13193b;
        .t1 {
          margin-left: 64px;
          font-size: 34px;
          color: #fff;
          margin-top: 57px;
        }
        .t2 {
          margin-left: 64px;
          margin-top: 20px;
          display: flex;
          align-items: center;
          .logo {
            width: 16px;
            height: 16px;
            background: url(~@/assets/images/wx.png);
            background-size: cover;
            background-repeat: no-repeat;
          }
          .t_1 {
            margin-left: 4px;
            font-size: 20px;
            color: #f5f5f5;
          }
        }
        .t3 {
          margin-left: 64px;
          margin-top: 16px;
          display: flex;
          align-items: center;
          .logo {
            width: 16px;
            height: 16px;
            background: url(~@/assets/images/qq.png);
            background-size: cover;
            background-repeat: no-repeat;
          }
          .t_1 {
            margin-left: 4px;
            font-size: 20px;
            color: #f5f5f5;
          }
        }
      }
    }
  }
  .box_3 {
    width: 1440px;
    height: 474px;
    background: url(~@/assets/images/address.png);
    background-size: cover;
    background-repeat: no-repeat;
    margin-top: 44px;
  }
  .kong {
    width: 100%;
    height: 64px;
  }
}
</style>
